import { useMutation, MutationHookOptions } from '@companyon/graphql';
import { DELETE_CARD_ATTACHMENT_MUTATION } from '../../schema/mutations/deleteCardAttachment';

export function useDeleteCardAttachmentMutation(options?: MutationHookOptions) {
  return useMutation(DELETE_CARD_ATTACHMENT_MUTATION, options);
}
